import { TReduxActions } from '../../../common/actions';
import { EFiltersActionType } from '../../../common/actions/filters';
import { EListingModalActionType, EOffersFetchingMode } from '../../../common/actions/listingModal';
import { EIsFirstMapInteractionActionType } from '../../actions';

export const defaultState = true;

export function isFirstMapInteractionReducer(state: boolean = defaultState, action: TReduxActions): boolean {
  switch (action.type) {
    case EListingModalActionType.Toggle:
      if (action.payload.open && action.payload.offersFetchingMode === EOffersFetchingMode.ALL) {
        return true;
      }
      break;
    case EFiltersActionType.JsonQueryChanged:
      return true;
    case EIsFirstMapInteractionActionType.Toggle:
      return action.payload;
  }

  return state;
}
